import React, { Component } from 'react';
import { Flex, Form, Select, Table } from 'antd';
import Card from 'antd/es/card/Card';
import Text from 'antd/es/typography/Text';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import dayjs from 'dayjs';
import { GameTypeEnum, IGameItem } from '../../games/store/game.types';

const NAME_COLOR = '#bcf3b4';

class _StatisticUser extends Component<IRootStoreProps> {
  componentDidMount(): void {
    this.props.store.user.getAllGames();
  }

  render() {
    const { gamesStatParams, gamesStatList, gamesStatTotal, handleStatGamesTableChange, changeTypeStatGames } =
      this.props.store.user;
    const columns = [
      {
        title: 'ID',
        dataIndex: 'gameId',
        key: 'gameId',
        render: (id: string) => (
          <Text ellipsis={{ tooltip: id }} style={{ maxWidth: 50 }}>
            {id}
          </Text>
        ),
      },
      {
        title: 'Создал',
        dataIndex: 'ownerName',
        key: 'ownerName',
        render: (name: number, item: IGameItem) => {
          const color = item.ownerId == item.winnerId ? NAME_COLOR : undefined;
          return (
            <Flex style={{ backgroundColor: color, borderRadius: 5 }} justify={'center'}>
              <Text>{name}</Text>
            </Flex>
          );
        },
      },
      {
        title: 'Сыграл',
        dataIndex: 'playerName',
        key: 'playerName',
        render: (name: number, item: IGameItem) => {
          const color = item.playerId == item.winnerId ? NAME_COLOR : undefined;
          return (
            <Flex style={{ backgroundColor: color, borderRadius: 5 }} justify={'center'}>
              <Text>{name}</Text>
            </Flex>
          );
        },
      },
      { title: 'Сумма', dataIndex: 'betAmount', key: 'betAmount', sorter: true },

      {
        title: 'Время',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (time: string) => <Text>{time ? dayjs(time).format('HH:mm:ss') : ''}</Text>,
      },
    ];

    return (
      <Card bordered={false} title="Статистика пользователя" style={{ marginBottom: 8 }}>
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 14 }} style={{ maxWidth: 600 }}>
          <Form.Item label="Выбор игры">
            <Select defaultValue={GameTypeEnum.KNB} onChange={changeTypeStatGames}>
              <Select.Option value={GameTypeEnum.KNB}>Камень ножницы бумага</Select.Option>
              <Select.Option value={GameTypeEnum.HOT}>Орел и решка</Select.Option>
            </Select>
          </Form.Item>
        </Form>
        <Table
          dataSource={gamesStatList}
          columns={columns}
          pagination={{ total: gamesStatTotal, pageSize: gamesStatParams.limit }}
          onChange={handleStatGamesTableChange}
        />
      </Card>
    );
  }
}

export const StatisticUserPage: WithoutStore = withStore(observer(_StatisticUser));
